import React, { useState, useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { map, get, forEach, includes } from "lodash"
import { Panel } from "./index"
import { MiniChartComponent } from "components/molecules/chart/miniChart"
import { Labels } from "components/atoms/input/input"
import { tableColumns } from "config/table_columns"
import { SeparateTable, BaseTable } from "components/molecules/table"
import { MiniChartListLegFilter } from "components/atoms/chart/parts/ChartLegFilter"
import { TERM } from "components/atoms/chart/logic/chartConfig"
import { changeTerm } from "redux/ducks/Chart"
import { checkIsSp } from "utils/util"
import uuid from "uuid"
import ClassNames from "classnames"
import { useLodingTrigger } from "components/actions/loading"

type LabelList = {
  name: string
  id: string | number
}

type PropsType = {
  indexData: Array<object>
  delete?: Function
  reloadList?: Function
  onClick?: Function
  setVisible?: Function
  selectData?: number
  setSelectData?: Function
  canvasId?: string
  domesticSummaryFlag?: boolean
  addClass?: string
  scrollable?: boolean
}

export const MainIndexList = (props: PropsType) => {
  const [displayList, changeDisplay] = useState({ type: 1 })
  const [legValue, setLegValue] = useState(TERM[8].id)
  const [screenSize, setScreenSize] = useState(window.outerWidth)
  const dispatch = useDispatch()
  const miniChartId = useMemo(() => {
    const idList: Array<string> = []
    forEach(props.indexData, () => {
      idList.push(uuid())
    })
    return idList
  }, [props.indexData])
  const label: Array<LabelList> = [
    { name: "一覧", id: 1 },
    { name: "ミニチャート", id: 2 },
  ]
  const changeList: Function = (id: number) => {
    changeDisplay({ type: id })
  }

  const changeChartLeg = (id: string) => {
    forEach(miniChartId, items => {
      dispatch(changeTerm(items, Number(id)))
    })
    setLegValue(Number(id))
  }

  useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenSize(window.innerWidth)
    })
  })

  useEffect(() => {
    if (!props.setVisible) return
    if (includes(displayList, 2)) return props.setVisible(false)
    props.setVisible(true)
  }, [displayList])

  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const { loadingTrigger } = useLodingTrigger()

  return (
    <Panel
      title=""
      className={ClassNames("panel-main-index", {
        "list-panel": displayList.type === 1,
      })}
      delete={props.delete}
      // refresh={props.reloadList}
      nonePanelHeader={isPhone}
      filter={
        <div className="control-row panel-header-filter">
          {!isPhone && (
            <Labels
              className="btn-segmented-control btn-thin liquid-control filter-control-item"
              labelList={label}
              checked={displayList.type}
              onChange={(id: number) => {
                loadingTrigger.setLoading(true)
                changeList(id)
                props.setSelectData && props.setSelectData(0)
              }}
            />
          )}
          {displayList.type === label[1].id ? (
            <MiniChartListLegFilter
              onChange={changeChartLeg}
              defaltValueId={legValue}
            />
          ) : null}
        </div>
      }
    >
      <div className={ClassNames("summary-chart-panel", props.addClass)}>
        {displayList.type === 1 ? (
          props.scrollable ? (
            <SeparateTable
              className="table-list-view table-liquid-cell"
              list={tableColumns.index.summary}
              data={props.indexData}
              active={props.selectData}
              onClick={(row: object, i: number) => {
                props.onClick && props.onClick(row, i)
                props.setSelectData && props.setSelectData(i)
              }}
              scrollable={screenSize > 559}
            />
          ) : (
            <BaseTable
              className="table-list-view table-liquid-cell"
              list={tableColumns.index.summary}
              data={props.indexData}
              active={props.selectData}
              onClick={(row: object, i: number) => {
                props.onClick && props.onClick(row, i)
                props.setSelectData && props.setSelectData(i)
              }}
            />
          )
        ) : (
          <ul className="chart-list-contents chart-list thin chart-mini-contents">
            {map(props.indexData, (row, key: number) =>
              get(row, "ChartFlg") ? (
                <MiniChartComponent
                  key={key}
                  data={row}
                  id={miniChartId[key]}
                  lineType={props.domesticSummaryFlag ? false : true}
                />
              ) : null
            )}
          </ul>
        )}
      </div>
    </Panel>
  )
}
